import React from 'react';

type ConnectionStatus = 'healthy' | 'validating' | 'disconnected' | 'idle';

interface ConnectionIndicatorProps {
  status: ConnectionStatus;
  latencyMs?: number | null;
  onClick?: () => void;
  size?: 'sm' | 'md';
}

export function ConnectionIndicator({ 
  status, 
  latencyMs, 
  onClick, 
  size = 'sm' 
}: ConnectionIndicatorProps) {
  
  // Determinar classes de estilo baseado no status
  const getStatusClasses = () => {
    const baseSize = size === 'sm' ? 'w-2 h-2' : 'w-3 h-3';
    
    switch (status) {
      case 'healthy':
        return `${baseSize} rounded-full bg-emerald-500`;
      
      case 'validating':
        return `${baseSize} rounded-full bg-amber-500 animate-pulse`;
      
      case 'disconnected':
        return `${baseSize} rounded-full bg-red-500 animate-pulse`;
      
      case 'idle':
      default:
        return `${baseSize} rounded-full bg-gray-600`;
    }
  };

  // Determinar tooltip baseado no status
  const getTooltip = () => {
    switch (status) {
      case 'healthy':
        return latencyMs 
          ? `CorelDRAW conectado (${latencyMs}ms)`
          : 'CorelDRAW conectado';
      
      case 'validating':
        return 'Verificando conexão...';
      
      case 'disconnected':
        return 'CorelDRAW desconectado - Clique para reconectar';
      
      case 'idle':
      default:
        return 'Aguardando validação';
    }
  };

  // Determinar se é clicável
  const isClickable = status === 'disconnected' && onClick;

  // Determinar cursor
  const cursorClass = isClickable ? 'cursor-pointer' : 'cursor-default';

  // Handler de clique
  const handleClick = () => {
    if (isClickable && onClick) {
      onClick();
    }
  };

  return (
    <div
      className={`flex items-center justify-center ${cursorClass}`}
      title={getTooltip()}
      onClick={handleClick}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onKeyDown={(e) => {
        if (isClickable && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      <div className={getStatusClasses()} />
    </div>
  );
}

